import { Component, OnInit, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto,
  PollParserInboxesStatisticsDto,
  PollParserType,
} from 'src/app/core/api/models';
import { CompetitionParserService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { BaseParserIndexComponent } from '../base-parser/base-parser-index.component';
import { ParserStatsComponent } from '../parser-stats/parser-stats.component';
import { PollParserInboxesComponent } from '../poll-parser-inboxes/poll-parser-inboxes.component';
import { CompetitionParserFormPageComponent } from './competition-parser-form-page/competition-parser-form-page.component';

@Component({
  selector: 'app-competition-parser',
  templateUrl: './competition-parser.component.html',
  imports: [
    BaseIndexModule,
    CompetitionParserFormPageComponent,
    ParserStatsComponent,
    PollParserInboxesComponent,
  ],
})
export class CompetitionParserComponent
  extends BaseParserIndexComponent
  implements OnInit
{
  pageName = 'pollParsers';

  protected currentService = inject(CompetitionParserService);
  createGetApiMethodName: string =
    this.currentService.competitionParserCreateGet.name;
  auditApiMethodName: string =
    this.currentService.competitionParserGetPollParserAudits.name;
  deleteApiMethodName: string =
    this.currentService.competitionParserDelete.name;

  get PollParserType() {
    return PollParserType;
  }

  statsModel: PollParserInboxesStatisticsDto;
  isShowStats: boolean = false;
  statType: 'survey' | 'competition' = 'competition';

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.title = this.pageVocabs + 'competitionTitle';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Stats_key)
        this.onShowStats(+value, false);
      if (key == QueryStringTypesEnum.Update_key) this.onUpdate(+value, false);
    }
  }
  //#region Api

  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto> {
    return this.currentService.competitionParserGetWithPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        type: PollParserType.Competition,
      },
    });
  }

  //get by id
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .competitionParserUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  updateIsActiveApi(pollParserId: number, isActive: boolean): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .competitionParserUpdateIsActive({ body: { isActive, pollParserId } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  getPollParserFormulaApi(parserId, type: 'inbox' | 'lottery') {
    this.currentService
      .competitionParserGetPollParserFormulaById({ PollParserId: parserId })
      .pipe(this.basePipeOperators())
      .subscribe((pollParserFormula) => {
        this.pollParserFormula = pollParserFormula?.data;
        if (type == 'inbox') {
          if (pollParserFormula?.data?.length > 0)
            this.onPollParserInboxes(parserId, pollParserFormula?.data);
          else this.isVisiblePollParserInboxes = true;
        } else if (type == 'lottery') {
          this.onPollParserLottery(parserId, pollParserFormula?.data);
        }
      });
  }

  //#endregion

  //Get Stats By Id
  onShowStats(id: any, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Stats_key +
          '=' +
          id
      );
    }
    this.unSubs();
    this.pageConfig.loading = true;

    this.inboxService
      .inboxesGetInboxesStatisticsByPollParserId({
        PollParserId: id.toString(),
      })
      .pipe(
        map((res) => res.data),
        this.basePipeOperators()
      )
      .subscribe((res: PollParserInboxesStatisticsDto) => {
        try {
          this.statsModel = res;
          this.isShowStats = true;
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.services);
        }
      });
  }
  isCloseStats() {
    this.isShowStats = false;
  }
}
